import React from 'react';
import '../../estilos/perfil/perfil.css'
import NoContentPage from '../noContent/noContentPage'
//import MainImage from './MainImage';

const Audiolibros = () => {
    return (
        <div className="pagina-inicio">
           
            <div className="content">
            <NoContentPage/>
            </div>
        </div>
    );
};

export default Audiolibros;
